import { render, staticRenderFns } from "./reportOnlyOffice.vue?vue&type=template&id=5c7ae4f9&scoped=true"
import script from "./reportOnlyOffice.vue?vue&type=script&lang=js"
export * from "./reportOnlyOffice.vue?vue&type=script&lang=js"
import style0 from "./reportOnlyOffice.vue?vue&type=style&index=0&id=5c7ae4f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ae4f9",
  null
  
)

export default component.exports